import { ChangeDetectorRef, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import autobind from "autobind-decorator";
import { SpsIcon } from "@spscommerce/ds-shared";

@Component({
    selector: "sps-card-tabbed-pane",
    templateUrl: "./sps-card-tabbed-pane.component.html",
    encapsulation: ViewEncapsulation.Emulated
})
export class SpsCardTabbedPaneComponent {
    static readonly displayName = "sps-card-tabbed-pane";
    static readonly props = {
        label: {
            type: "string",
            required: true,
        },
        icon: "SpsIcon",
        tag: "string",
    };
    private static idCounter = 0;

    @Input() label: string;
    @Input() id: string;
    @Input() icon: SpsIcon;
    @Input() tag: string;

    @HostBinding("style.display")
    get display(): string {
        return this.isActive ? "block" : "none";
    }

    @HostBinding("class.sps-tab__pane") readonly _classSpsTabPane = true;
    @HostBinding("attr.role") readonly _attrRole = "tabpanel";
    @HostBinding("attr.aria-labelledby")
    get tabId() {
        return `${this.id}~tab`;
    }

    private _isActive = false;
    get isActive() {
        return this._isActive;
    }

    constructor(private changeDetector: ChangeDetectorRef) {
        // This means you no longer *have to* give a pane an id. (Though you still can & it will overwrite this)
        this.id = `spsCardTabbedPane_${SpsCardTabbedPaneComponent.idCounter++}`;
    }

    @autobind
    activate() {
        this._isActive = true;
        this.changeDetector.markForCheck();
    }

    @autobind
    deactivate() {
        this._isActive = false;
        this.changeDetector.markForCheck();
    }
}
